module.exports = __webpack_public_path__ + "static/media/car.a91dfde4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/car.svg
// module id = 1131
// module chunks = 0